import { createContext } from 'react'

// Context to pass mobile state to filter components
export const MobileFilterContext = createContext({ isMobile: false })
